/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Der Bestellung hinzufügen",
  "i18n.additionalProducts.emotionalHook": "♥️ Beliebt:",
  "i18n.additionalProducts.productDescription": "Produktbeschreibung",
  "i18n.additionalProducts.showMore": "Mehr Infos",
  "i18n.additionalProducts.title": "Passendes Zubehör",
  "i18n.button.addToCart": "In den Warenkorb",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Übernehmen",
  "i18n.button.back": "Zurück",
  "i18n.button.cancel": "Abbrechen",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Schließen",
  "i18n.button.continue": "Weiter",
  "i18n.button.ignore": "Ignorieren",
  "i18n.button.ignoreAndContinue": "Trotzdem weiter",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "keine Änderung",
  "i18n.button.design": "",
  "i18n.button.photos": "Fotos",
  "i18n.button.retry": "Erneut versuchen",
  "i18n.button.uploadPhotos": "Fotos hochladen",
  "i18n.button.withSmartSorted": "Mit SMART SORTED",
  "i18n.button.withoutSmartSorted": "Ohne SMART SORTED",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "Gestalte deine Puzzle-Schachtel",
  "i18n.boxPromoter.title.memo": "Gestalte deine Memo-Schachtel",
  "i18n.boxPromoter.title.default": "Gestalte deine Schachtel",
  "i18n.boxPromoter.content.designsAndText": "Du kannst aus mehreren Designs wählen und einen Text hinzufügen.",
  "i18n.boxPromoter.content.designs": "Du kannst aus mehreren Designs wählen.",
  "i18n.boxPromoter.content.text": "Du kannst einen Text hinzufügen.",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Für bessere Lesbarkeit bitte Textlänge / Zeilenlänge kürzen.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Die gewählte Schriftart ist zu groß für diesen Text.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Die maximal mögliche Schriftgröße für diesen Text wurde ausgewählt.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Die minimal mögliche Schriftgröße wurde ausgewählt.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Bitte Zeilenumbruch einfügen.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Bitte Zeilenumbruch einfügen oder Textfeld vergrößern.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Bitte überprüfe Deine Eingaben, nicht alle Zeichen werden von dieser Schriftart unterstützt.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Maximale Textlänge erreicht",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Die maximale Anzahl an Zeilen ist erreicht.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Bitte Textfeld vergrößern.",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Dieser Schritt kann nicht rückgängig gemacht werden.",
  "i18n.dialog.deletePlaceholder.title": "Platzhalter wirklich löschen?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "Die Auflösung dieses Bildes ist zu gering, um das Motiv optimal zu drucken!",
  "i18n.dialog.smartSorted.message": "Mit SMART SORTED puzzelt Ihr innovativ und mühelos euer Motiv mit 1000 Teilen auch ohne Motiv-Vorlage",
  "i18n.dialog.smartSorted.title": "Puzzle-Erfolgserlebnis garantiert",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Bitte klicke auf „{{text}}“, um den Titel Deinen Wünschen anzupassen.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Der Schachteltitel wurde nicht geändert.",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Weiter ohne Text",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Ein Platzhalter wurde nicht geändert.",
    "Mehrere Platzhalter wurden nicht geändert."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "unveränderte Platzhalter",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Du hast die Gestaltung für längere Zeit unterbrochen. Sie kann nicht fortgeführt werden. Bitte starte den Vorgang erneut.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Ein Bild konnte nicht geladen werden.\nEs wurde aus der Galerie und der Gestaltungsfläche entfernt.",
  "i18n.error.imageLoadingError.title": "Ladefehler",
  "i18n.error.imageProvisionError.message": "Ein oder mehrere Bilder konnte nicht verarbeitet werden. Möglicherweise wird das Format nicht unterstützt.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Die Datei „{{reference1}}“ konnte nicht verarbeitet werden.",
  "i18n.error.imageSelectionError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.imageSizeLimitExceededError.message": "Das von Dir hochgeladene Bild hat zu große Abmessungen.\nAus technischen Gründen können wir es nicht verarbeiten.\nBitte verkleinere das Bild auf weniger als 180 Megapixel und lade es erneut hoch.",
  "i18n.error.imageSizeLimitExceededError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.imageUploadError.message": "Es scheint ein Problem mit der Internetverbindung zu geben.\nBitte versuche es zu einem späteren Zeitpunkt noch einmal.",
  "i18n.error.imageUploadError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Die Schriftart ist fehlerhaft und kann nicht verwendet werden.",
  "i18n.error.invalidCharConfigError.title": "Fehlerhafte Schriftart",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Deine Internetverbindung scheint unterbrochen zu sein. Du kannst mit der Gestaltung fortfahren, sobald die Verbindung wieder hergestellt wurde.",
  "i18n.error.templateLoadingError.message": "Das Template „{{ error.reference[0] }}“ konnte nicht geladen werden.\nBitte versuche es zu einem späteren Zeitpunkt noch einmal.",
  "i18n.error.templateLoadingError.title": "Ladefehler",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "Nicht unterstütztes Bildformat für „{{reference1}}“.",
  "i18n.error.unsupportedMediaTypeError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.uploadProductError.message": "Ein oder mehrere Produkte konnten nicht auf den Server übertragen werden.\nMöglicherweise liegt ein Problem mit der Internetverbindung vor.",
  "i18n.error.uploadProductError.title": "Übertragungsfehler",
  "i18n.error.zoomModeError.message": "Dein Text aus dem vorherigen Design konnte nicht übernommen werden und wurde zurückgesetzt.",
  "i18n.error.zoomModeError.title": "Text nicht übernommen",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Preis",
  "i18n.price.reduction": "Du sparst",
  "i18n.price.total": "Gesamtpreis",
  "i18n.priceDisplay.times": [
    "{{value}} Stück à {{pricePerUnit}}",
    "{{value}} Stück à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Zubehör wählen",
  "i18n.progressOverlay.message.lines.one": "Danke für die schöne Gestaltung.",
  "i18n.progressOverlay.message.lines.two": "Wir bereiten alles für Dich vor...",
  "i18n.template.insertText": "Hier Text eingeben",
  "i18n.toolbox.image.title": "Bild bearbeiten",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 Bild",
    "{{value}} Bilder"
  ],
  "i18n.toolbox.layout.title": "Designs",
  "i18n.toolbox.layout.titleBox": "Schachtel-Designs",
  "i18n.toolbox.preview.title": "3D Vorschau",
  "i18n.toolbox.productChooser.title": "Produkt wechseln",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Text bearbeiten",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleDeAT {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
